import React, { useEffect } from 'react';
import { useSettings } from '../hooks/useSettings';

const GlobalTracker: React.FC = () => {
    const { settings } = useSettings();

    useEffect(() => {
        if (!settings) return;

        // Injetar Google Analytics
        if (settings.google_analytics_id && !window.hasOwnProperty('gtag')) {
            const script1 = document.createElement('script');
            script1.async = true;
            script1.src = `https://www.googletagmanager.com/gtag/js?id=${settings.google_analytics_id}`;
            document.head.appendChild(script1);

            const script2 = document.createElement('script');
            script2.innerHTML = `
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
                gtag('config', '${settings.google_analytics_id}');
            `;
            document.head.appendChild(script2);
        }

        // Injetar Meta Pixel
        if (settings.meta_pixel_id && !window.hasOwnProperty('fbq')) {
            const pixelScript = document.createElement('script');
            pixelScript.innerHTML = `
                !function(f,b,e,v,n,t,s)
                {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                n.queue=[];t=b.createElement(e);t.async=!0;
                t.src=v;s=b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t,s)}(window, document,'script',
                'https://connect.facebook.net/en_US/fbevents.js');
                fbq('init', '${settings.meta_pixel_id}');
                fbq('track', 'PageView');
            `;
            document.head.appendChild(pixelScript);
        }

        // SEO Dinâmico foi removido daqui e transferido para o componente src/components/SEO.tsx (react-helmet-async)
        
    }, [settings]);

    return null;
}
export default GlobalTracker;
